module.exports = __webpack_public_path__ + "img/olsera_logo.4b3f8e0c.png";